import React from "react";
import Navbar from "../Components/Navbar";
import About from "./../Components/About";

function About_Page() {
  return (
    <>
      <Navbar />
      <About />
    </>
  );
}

export default About_Page;
